/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Čekající`
};

const da_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Afventer`
};

const de_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Ausstehend`
};

const en_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Pending`
};

const es_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Pendiente`
};

const fr_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `En attente`
};

const hu_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Függőben`
};

const it_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `In attesa`
};

const nl_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `In afwachting`
};

const pl_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Oczekuje`
};

const pt_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Pendente`
};

const sv_order_statuses_pending = /** @type {(inputs: {}) => string} */ () => {
	return `Väntande`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_pending = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_pending(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_pending", locale)
	if (locale === "cs") return cs_order_statuses_pending(inputs)
	if (locale === "da") return da_order_statuses_pending(inputs)
	if (locale === "de") return de_order_statuses_pending(inputs)
	if (locale === "en") return en_order_statuses_pending(inputs)
	if (locale === "es") return es_order_statuses_pending(inputs)
	if (locale === "fr") return fr_order_statuses_pending(inputs)
	if (locale === "hu") return hu_order_statuses_pending(inputs)
	if (locale === "it") return it_order_statuses_pending(inputs)
	if (locale === "nl") return nl_order_statuses_pending(inputs)
	if (locale === "pl") return pl_order_statuses_pending(inputs)
	if (locale === "pt") return pt_order_statuses_pending(inputs)
	return sv_order_statuses_pending(inputs)
};
export { order_statuses_pending as "order_statuses.pending" }